const toRgba = (hex, alpha) => {
  if (!hex || !hex.startsWith("#")) return `rgba(var(--vz-primary-rgb), ${alpha})`;
  const value = hex.slice(1);
  const full = value.length === 3
    ? value.split("").map(ch => ch + ch).join("")
    : value;
  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const postureIconChipStyle = (color = "#FF5B00") => ({
  width: "32px",
  height: "32px",
  borderRadius: "8px",
  border: `1px solid ${toRgba(color, 0.22)}`,
  background: toRgba(color, 0.08),
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

export const postureIconStyle = (color = "#FF5B00") => ({
  color,
  fontSize: "16px",
});

export const postureGlyphStyle = {
  fontSize: "16px",
};

export const postureAlertIconChipStyle = (color = "#dc3545") => ({
  ...postureIconChipStyle(color),
});

export const postureAlertIconStyle = (color = "#dc3545") => ({
  color,
  fontSize: "16px",
});
